import type { CustomCellRendererProps } from "ag-grid-react";
import { DECIMAL_2 } from "presentation/utils/numberUtil";
import { defineColumn, transferRowDataInternal } from "presentation/view/components/TableWrapper/BasicTableConstants";
import { TransferOfChargeConstant } from "./TransferOfChargeConstant";
let dateFieldList: string[] = [];
let dateTimeFieldList: string[] = [];
let numberFieldList: string[] = [];
const SCREEN_CONSTANT = TransferOfChargeConstant;
export const INITIAL_TRANSFER_OF_CHARGE_COL_DEF: any[] = [
    {
        headerName: SCREEN_CONSTANT.STATE,
        field: "dtlState",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        pinned: "left",
        checkboxSelection: true,
        headerCheckboxSelection: true,
    },
    {
        headerName: SCREEN_CONSTANT.SEQ_NO,
        field: "seqNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.CHARGEON_COMPANY,
        field: "chargeOnCompany",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.BILLTO_COMPANY,
        field: "billToCompany",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.CONSORTIUM_CODE,
        field: "consortiumCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.VESSEL_CODE,
        field: "vesselCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.VOYAGE_CODE,
        field: "voyageCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.ETD,
        field: "etd",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.CHARGE_TYPE,
        field: "chargeType",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.SUB_CHARGE_TYPE,
        field: "subChargeType",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.CONTAINER_NO,
        field: "cntrNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.STATUS,
        field: "status",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.SIZE,
        field: "cntrSize",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.TYPE,
        field: "cntrType",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.SERVICE_ORDER_CODE,
        field: "serviceOrderCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.TARIFF_TYPE,
        field: "tariffType",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.TARIFF_CODE,
        field: "tariffCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.QTY,
        field: "qty",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: SCREEN_CONSTANT.UOM,
        field: "uom",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.OPS_LINE,
        field: "opsLine",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.CNIC_NO,
        field: "cnicNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.VEHICLE_NO,
        field: "vehicleNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.DAMAGE_TYPE,
        field: "damageType",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.AMOUNT,
        field: "amount",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: SCREEN_CONSTANT.REMARKS,
        field: "remark",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.COMMODITY_CODE,
        field: "commodityCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.SHIPPER__CONSIGNEE,
        field: "counterCustCompCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.DRAFT_INVOICE_NO,
        field: "draftInvoiceNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.FINAL_INVOICE_NO,
        field: "finalInvoiceNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.DRAFT_CREDIT_NOTE_NO,
        field: "draftCreditNoteNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.FINAL_CREDIT_NOTE_NO,
        field: "finalCreditNoteNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.ADJ_TYPE,
        field: "adjType",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.MANUAL_CHARGE_NO,
        field: "mcNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.CREDIT_CHARGE_NO,
        field: "crNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.CONTAINER_TYPE_GROUP,
        field: "cntrTypeGroup",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.OPS_DATE,
        field: "opsDate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "date",
    },
    {
        headerName: SCREEN_CONSTANT.BILL_OF_LADING__REF_NO,
        field: "billOfLading",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.SHIPPING_BILL,
        field: "shippingBill",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.SERVICE_CODE,
        field: "serviceCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.AGENT_NO,
        field: "agentNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.AGENT_NAME,
        field: "agentName",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.PAID_THROUGH_DATE,
        field: "paidThroughDate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.OPERATING_TML,
        field: "operatingTml",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.CHANGE_DATETIME,
        field: "changeDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.RELEASE_DATETIME,
        field: "releaseDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.ONEOFF_RATE,
        field: "oneoffRate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: SCREEN_CONSTANT.SPECIAL_IND,
        field: "specialInd",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.VESSEL_NAME,
        field: "vesselName",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.ORI_OWNER,
        field: "oriOwner",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.ORI_STATUS,
        field: "oriStatus",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.NEW_OWNER,
        field: "newOwner",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.NEW_STATUS,
        field: "newStatus",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.CHARGE_CODE,
        field: "chargeCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.TELEX_NO,
        field: "telexNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.CHARGE_IND,
        field: "chargeInd",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.SHIPMENT_TYPE,
        field: "shipmentType",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.FORWARDER_REF,
        field: "forwarderReference",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.BARGE_JOB_ID,
        field: "bageJobID",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.ARR_DATETIME,
        field: "arrDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.OTHER_ARR_DATETIME,
        field: "otherArrDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.OTHER_DEP_DATETIME,
        field: "otherDepDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.OTHER_SERVICE,
        field: "otherService",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.POD2,
        field: "pod2",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.POD_GEOG_IND,
        field: "pod1GeogInd",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.REQUEST_DATETIME,
        field: "requestDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.REASON_CODE,
        field: "reasonCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.RECEIVE_DATETIME,
        field: "receiveDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.LOADING_DATE_TIME,
        field: "loadingDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.FIRST_LOADING_DATETIME,
        field: "firstLoadingDataTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.LAST_LOADING_DATETIME,
        field: "lastLoadingDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.CHARGING_FROM_DATETIME,
        field: "chargingFromDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.CHARGING_TO_DATETIME,
        field: "chargingToDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.RECEVAL_CUTOFF_TIME,
        field: "recevalCutoffDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.ST_TIER_FSP,
        field: "firstTierFsp",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.ND_TIER_FSP,
        field: "secondTierFsp",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.CHARGING_QTY_ADJUST,
        field: "chargingQtyAdjust",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: SCREEN_CONSTANT.CALENDAR_ADJUST_CHARGE_QTY,
        field: "calendarAdjustChargeqty",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: SCREEN_CONSTANT.MANUAL_ADJUST_CHARGE_QTY,
        field: "manualAdjustChargeQty",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: SCREEN_CONSTANT.MANUAL_ADJUST_UOM,
        field: "manualAdjustUOM",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.DG_CONTENT,
        field: "dgContent",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.DU_CONTENT,
        field: "duContent",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.PERMIT_NO,
        field: "permitNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.RF_TEMP,
        field: "rfTemp",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: SCREEN_CONSTANT.RF_TEMP_UNIT,
        field: "rfTempUnit",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.DIRECTINDIRECT_DISCHARGE_IND,
        field: "dIndDischargeInd",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.SO_NUMBER,
        field: "soNumber",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.TRAIN_ID,
        field: "trainId",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.TRACTOR_NO,
        field: "tractorNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.FD_GEOG_IND,
        field: "fdGeogInd",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.WAIVER_NO,
        field: "waiverNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.POO_GEOG_IND,
        field: "pooGeogInd",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.POL_GEOG_IND,
        field: "polGeogInd",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.EQUIPMENT_CODE_IND,
        field: "eqCodeInd",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.EQUIPMENT_CODE,
        field: "eqCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.NO_OF_STORAGE,
        field: "noOfStorage",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: SCREEN_CONSTANT.DISCHARGE_DATETIME,
        field: "dischargeDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.FIRST_DISCHARGE_DATETIME,
        field: "firstDischargeDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.LAST_DISCHARGE_DATETIME,
        field: "lastDischargeDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.EXPIRY_DATETIME,
        field: "expDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.DELIVERY_DATETIME,
        field: "deliveryDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.ATB_DATETIME,
        field: "atb",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.CASH_OT_DAYS,
        field: "cashOtDays",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: SCREEN_CONSTANT.CASH_AMOUNT,
        field: "cashAmount",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: SCREEN_CONSTANT.CASH_RECEIPT_NO,
        field: "cashReceiptNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.IMCO_CODE,
        field: "imcoCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.SPECIAL_CODE,
        field: "specialCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.SPECIAL_HANDLING_IND,
        field: "spHandlingInd",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.POO,
        field: "poo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.POL,
        field: "pol",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.POD,
        field: "pod",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.FD,
        field: "fd",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.POO_COUNTRY,
        field: "pooCountry",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.POL_COUNTRY,
        field: "polCountry",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.POD_COUNTRY,
        field: "podCountry",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.FD_COUNTRY,
        field: "fdCountry",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.EXCESS_WEIGHT,
        field: "excessWeight",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: SCREEN_CONSTANT.GROSS_WEIGHT,
        field: "grossWeight",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: SCREEN_CONSTANT.MAX_GROSS_WEIGHT,
        field: "maxGrossWeight",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: SCREEN_CONSTANT.CARGO_CODE,
        field: "cargoCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.WAIVER_REASON_CODE,
        field: "waiverReasonCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.WAIVER_REJECT_REASON,
        field: "waiverRejectReasonCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.WAIVER_APPROVED_BY,
        field: "waiverApprovedBy",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.WAIVER_APPROVED_DATE,
        field: "waiverApprovedDatetime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
        dataType: "dateTime",
    },
    {
        headerName: SCREEN_CONSTANT.EXCISE_CASH_NO,
        field: "exciseCashNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.LIFT_ONOFF_IND,
        field: "liftInd",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.NO_OF_WAIVED_DAYS,
        field: "waiverNoOfDays",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.SERVICE_REQUEST_REF,
        field: "serviceReferenceNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.SERVICE_REQUEST_CODE,
        field: "serviceRequestCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.SUBSERVICE_REQUEST_CODE,
        field: "subServiceRequestCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.LOCATION_TYPE,
        field: "lsLocationType",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.CNTR_NO_REF,
        field: "cntrNoRef",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.EXCEPTION_MSG,
        field: "exceptionMsg",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: false,
        width: 200,
    },

].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};
    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers, numberFieldList);
}
);

export const transferRowData = (data: any[]) => {
    const externalFnctions: { [key: string]: ((fieldName: string, row: any) => {}) } = {};
    return transferRowDataInternal(data, dateFieldList, dateTimeFieldList, [], externalFnctions, numberFieldList);
}
